import { AboutPage } from "../about/AboutPage";
import { mountPage } from "./mountPage";

mountPage("about-root", <AboutPage />);
